module.exports = __webpack_public_path__ + "media/high_school_students/header_bknd-46e9fb69.png";